import theme from "theme";

export const isMobile = () => window.innerWidth <= theme.screen.mobile;

export const isTablet = () => window.innerWidth <= theme.screen.tablet;

export const getBottomOfPage = () => {
  return document.documentElement.scrollHeight - window.innerHeight;
};
